/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {connect} from 'react-redux'
import {
    Page,
    WKError,
} from '../../components/index'
import {
    Header,
    Footer,
    ListTitle,
    LecturerListcurrent,
    LecturerListHistory,
    DefaultContent,
    LecturerInit,
} from '../../components/lecturerInvite/index'
import '../../css/page/LecturerInvitePage.css'


class LecturerInvitePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            urlData: {
                type: this.props.routeParams.type,
                target_id: this.props.routeParams.target_id
            },
            isSearchFixed: false
        };
        document.title = '嘉宾管理'
    }

    componentDidMount() {
        if (this.props.originalList && this.props.originalList.length > 0) {
            this.searchContainer = document.querySelector('.search-container');
            this.searchContainerTop = this.searchContainer && this.searchContainer.offsetTop;
            window.addEventListener('scroll', this.handleScroll);
        }
    }

    componentDidUpdate(prevProps) {
        // 当 originalList 从无到有时，添加监听并获取位置
        if ((!prevProps.originalList || !prevProps.originalList.length) && 
            this.props.originalList && this.props.originalList.length > 0) {
            this.searchContainer = document.querySelector('.search-container');
            this.searchContainerTop = this.searchContainer && this.searchContainer.offsetTop;
            window.addEventListener('scroll', this.handleScroll);
        }
        // 当 originalList 从有到无时，移除监听并重置状态
        if ((prevProps.originalList && prevProps.originalList.length) && 
            (!this.props.originalList || !this.props.originalList.length)) {
            window.removeEventListener('scroll', this.handleScroll);
            this.setState({ isSearchFixed: false });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const shouldFix = scrollTop >= this.searchContainerTop;
        
        if (shouldFix !== this.state.isSearchFixed) {
            this.setState({ isSearchFixed: shouldFix });
        }
    }

    render(){
        const {urlData, isSearchFixed} = this.state;
        const {currentList, selectedList, error, lectureInfo, originalList} = this.props;
        if (error.showError) {
            return (
                <div style={{background: '#fff', width: '100%', height: '100vh'}}>
                    <WKError />
                </div>
            )
        }

        const showDefaultContent = originalList && originalList.length === 0 && selectedList && selectedList.length === 0;

        return (
            <Page className="wrap-lecturer-invite-page">
                <div className="lecturer-invite-container">
                    <LecturerInit urlData={urlData}/>

                    <Header targetName={lectureInfo.name}/>

                    {selectedList && selectedList.length > 0 &&
                    <ListTitle title={"当前嘉宾"} type={'now'}/>
                    }
                    <LecturerListcurrent />
                    {/* {((originalList && originalList.length > 0) || (currentList && currentList.length > 0)) &&
                    <ListTitle title={"历史嘉宾"} type={'history'}/>
                    } */}
                    <LecturerListHistory isSearchFixed={isSearchFixed} />
                    {!(currentList && currentList.length === 0 && selectedList && selectedList.length === 0) &&
                    <Footer urlData={urlData}/>
                    }

                    {showDefaultContent && <DefaultContent urlData={urlData}/>}

                </div>
            </Page>
        )
    }
}


export default connect(state => ({
    lectureInfo: state.lecturerInvite.lectureInfo,
    currentList: state.lecturerInvite.currentList,
    selectedList: state.lecturerInvite.selectedList,
    error: state.error,
    originalList: state.lecturerInvite.originalList
}))(LecturerInvitePage)


// WEBPACK FOOTER //
// ./src/pages/lecutrerInvite/LecturerInvitePage.js